import { defineStore } from "pinia";
import { ref } from "vue";
import { INVENTORY_ENDPOINT } from "@/constants/Endpoints";
import axios from "axios";
import { LOGGER } from "@/util/logger";
import { clone } from "@/util/clone";
import { MODULE_TYPES } from "@/constants/InspectionConstants";
import { useInventoryStore } from "@/stores/inventory";

export const useMaintenanceStore = defineStore("maintenance", () => {
  //maintenance data is loaded either from idb (pouch db for inspection module) or service (for management module)
  let maintenanceData = ref({});
  let submitToSAPErrorMessages = ref([]);
  let candidatesSubmittedToSAP = ref(null);
  const inventoryStore = useInventoryStore();

  const loadMaintenanceObject = async (moduleType, brkey, structure) => {
    if (moduleType === MODULE_TYPES.INSPECTION) {
      //if moduleType is inspection, load data from pouchDB
      convertToInspModuleObject(structure);
    } else if (moduleType === MODULE_TYPES.MANAGEMENT) {
      //if moduleType is management, load data from service call
      await getInspLinkMaintenance(brkey);
    }
  };

  const getMaintenanceObject = () => {
    return clone(maintenanceData.value);
  };

  const saveMaintenance = async (moduleType, maintenanceValue, structure) => {
    let isSuccess = false;
    if (moduleType === MODULE_TYPES.INSPECTION) {
      convertToSaveInspModuleObject(maintenanceValue, structure);
      isSuccess = true;
    } else if (moduleType === MODULE_TYPES.MANAGEMENT) {
      isSuccess = await updateMaintenance(maintenanceValue);
    }
    return isSuccess;
  };

  const updateMaintenance = async (maintenance) => {
    let isSuccess = true;
    const url = INVENTORY_ENDPOINT.UPDATE_MAINTENANCE;
    await axios
      .put(url, maintenance)
      .then((response) => {
        LOGGER.logEvent(LOGGER.EventAction.Update, LOGGER.EventCat.RequestResponse, "Update Maintenance", response);
        maintenanceData.value = { ...response.data.data };
      })
      .catch((e) => {
        LOGGER.logException(e);
        isSuccess = false;
      });
    return isSuccess;
  };

  const submitMaintenanceItemsToSAP = async (brkey) => {
    submitToSAPErrorMessages.value = [];
    candidatesSubmittedToSAP.value = null;
    let url = INVENTORY_ENDPOINT.SUBMIT_MAINTENANCE_ITEMS_TO_SAP.replace("{brkey}", brkey);
    let isSuccess = false;
    await axios
      .post(url)
      .then((response) => {
        LOGGER.logEvent(
          LOGGER.EventAction.Submit,
          LOGGER.EventCat.RequestResponse,
          "Submit Maintenance Items To SAP",
          response
        );
        isSuccess = true;
        submitToSAPErrorMessages.value = response.data.data.errorMessages;
        candidatesSubmittedToSAP.value = response.data.data.candidatesSubmittedToSAP;
      })
      .catch((e) => {
        LOGGER.logException(e);
        isSuccess = false;
      });
    return isSuccess;
  };

  const convertToSaveInspModuleObject = (maintenanceValue, structure) => {
    structure.inspectionWcands = maintenanceValue.inspectionWcands;
  };

  const convertToInspModuleObject = (structure) => {
    maintenanceData.value = {
      brkey: structure.structureBridge.brkey,
      inspectionWcands: structure.inspectionWcands,
      structureUnits: structure.structureUnits,
    };
  };

  const getInspLinkMaintenance = async (brkey) => {
    maintenanceData.value = {};
    let url = INVENTORY_ENDPOINT.GET_MAINTENANCE.replace("{brkey}", brkey);
    inventoryStore.setIsSearching(true);
    await axios
      .get(url)
      .then((response) => {
        inventoryStore.setIsSearching(false);
        maintenanceData.value = { ...response.data.data };
      })
      .catch((e) => {
        LOGGER.logException(e);
        inventoryStore.setIsSearching(false);
      });
  };

  return {
    candidatesSubmittedToSAP,
    submitToSAPErrorMessages,
    submitMaintenanceItemsToSAP,
    maintenanceData,
    getMaintenanceObject,
    saveMaintenance,
    loadMaintenanceObject,
  };
});
